import { useEffect } from 'react';
import { t } from 'i18n-js';
import type { Machine, MachineGroup } from '@components/wallboard/types';

export interface UseManageMachinesGroupPopupParams {
  getMachinesGroup: () => void;
  machinesGroup: MachineGroup[];
  machines: Machine[];
  setIsPopupActive: (v: boolean | ((prev: boolean) => boolean)) => void;
  setFilterMachinesByGroup: (id: number | undefined) => void;
}

const useManageMachinesGroupPopup = ({
  getMachinesGroup,
  machinesGroup = [],
  machines,
  setIsPopupActive,
  setFilterMachinesByGroup,
}: UseManageMachinesGroupPopupParams) => {
  useEffect(() => {
    getMachinesGroup();
  }, []);

  const selectGroup = (i: { machineGroupId?: number }) => {
    setIsPopupActive(false);
    setFilterMachinesByGroup(i.machineGroupId);
  };

  const machinesGroupFormatted = machinesGroup.map((i) => {
    const machinesList = i?.machines?.length ? i.machines.map((m: any) => m.shortName).join(', ') : '-';
    return {
      ...i,
      bottom: machinesList,
      machinesList,
      onClick: () => {
        selectGroup(i);
      },
    };
  });

  machinesGroupFormatted.unshift({
    name: t('All machines'),
    machinesList: machines?.length ? machines.map((machine) => machine.shortName).join(', ') : '-',
  } as any);

  return {
    machinesGroupFormatted,
    selectGroup,
  };
};

export default useManageMachinesGroupPopup;
